import React, { useState } from 'react';

function ModeControls({ searchMode, searchModes, onSearchModeChange }) {
  const [isOpen, setIsOpen] = useState(false);

  if (searchModes.length === 0) {
    return null;
  }

  const currentMode = searchModes.find((mode) => mode.value === searchMode);
  const getButtonText = () => (currentMode ? currentMode.label : 'Select View');

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleModeSelect = (modeValue) => {
    onSearchModeChange(modeValue);
    setIsOpen(false);
  };

  return (
    <fieldset>
      <legend className="sr-only">Switch search results view mode</legend>

      <div className="md:hidden relative">
        <button
          type="button"
          className="text-sm font-medium flex items-center gap-3 px-5 py-3 bg-grey-100 w-full justify-between"
          aria-expanded={isOpen}
          onClick={handleToggle}
        >
          <span className="flex items-center gap-3">
            <span
              className={`size-4 min-w-4 rounded-full border-1 flex items-center justify-center
                ${
                  currentMode
                    ? 'border-transparent bg-[#2B8AAF]'
                    : 'bg-[#F3F4F6] border-[#D1D5DB]'
                }`}
            >
              {currentMode && (
                <span className="size-1.5 bg-[#F3F4F6] rounded-full" />
              )}
            </span>
            {getButtonText()}
          </span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            aria-hidden="true"
            focusable="false"
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
            }}
          >
            <use href="#icon-chevron-down" />
          </svg>
        </button>

        {isOpen && (
          <div className="z-50 absolute w-full bg-white top-full left-0 border border-[#ebebeb] border-t-0">
            {searchModes.map((mode) => (
              <button
                key={mode.value}
                type="button"
                className={`w-full text-left px-6 py-3 text-sm font-medium hover:bg-grey-100 ${
                  searchMode === mode.value ? 'bg-grey-100' : ''
                }`}
                onClick={() => handleModeSelect(mode.value)}
              >
                <span className="flex items-center gap-3 text-black">
                  <span
                    className={`size-4 min-w-4 rounded-full border-1 flex items-center justify-center
                      ${
                        searchMode === mode.value
                          ? 'border-transparent bg-[#2B8AAF]'
                          : 'bg-[#F3F4F6] border-[#D1D5DB]'
                      }`}
                  >
                    {searchMode === mode.value && (
                      <span className="size-1.5 bg-[#F3F4F6] rounded-full" />
                    )}
                  </span>
                  {mode.label}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="hidden md:flex flex-wrap">
        {searchModes.map((mode) => (
          <label
            key={mode.value}
            className={`view-mode cursor-pointer px-6 py-3 ${
              searchMode === mode.value ? 'bg-grey-100' : ''
            }`}
          >
            <span className="flex items-center gap-3 text-sm font-medium text-black">
              <input
                type="radio"
                name="searchMode"
                value={mode.value}
                checked={searchMode === mode.value}
                onChange={() => onSearchModeChange(mode.value)}
                className="sr-only peer"
              />
              <span
                className={`size-4 min-w-4 rounded-full border-1 flex items-center justify-center
                  ${
                    searchMode === mode.value
                      ? 'border-transparent bg-[#2B8AAF]'
                      : 'bg-[#F3F4F6] border-[#D1D5DB]'
                  }
                  peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-blue-700 peer-focus-visible:outline-offset-2`}
              >
                {searchMode === mode.value && (
                  <span className="size-1.5 bg-[#F3F4F6] rounded-full" />
                )}
              </span>
              {mode.label}
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
export default ModeControls;
